import { store, itiHttpService, itiMessageService, ItiString} from '@/iti-core-vue';
import { Action, getModule, Module, Mutation, VuexModule } from 'vuex-module-decorators';
import { API } from '@/shared/api';
import { Notification } from '@/shared/dtos/notificacion'

@Module({
  namespaced: true,
  name: 'ListaNotificacionesModule',
  store,
  dynamic: true,
})
class ListaNotificacionesModule extends VuexModule {
  public notificaciones: Notification[] = [];

@Mutation
public fijarNotificaciones(notificaciones: Notification[]){
  this.notificaciones = [...notificaciones];
}

@Action
public async cargarNotificaciones(){
  await itiHttpService.get(API.notifications, null, false)
      .catch((error) => { itiMessageService.toast(error, itiMessageService.TypeError); })
      .then((value) =>{
          if(Array.isArray(value)){
            this.context.commit('fijarNotificaciones', value);
          }
          else{
            this.context.commit('fijarNotificaciones', [value]);
          }
      } );
}

@Action
public async markNotificationAsRead(idNotificacion: number){
  const url = ItiString.Format('{0}', API.notifications);
  await itiHttpService.put(url, idNotificacion + '')
      .catch((error) => { itiMessageService.toast(error, itiMessageService.TypeError); })
      .then((value) =>{
        return value;
      } );
}

@Mutation
public anyadirNotificacion(notificacion: Notification){
  this.notificaciones = [notificacion, ...this.notificaciones];
}

@Action
public async addNotificacion(notificacion: Notification){
  this.context.commit('anyadirNotificacion', notificacion);
}

}
export default getModule(ListaNotificacionesModule);
